import React from 'react';
import { HelpRouterFragment } from './help-router.interface';
import { SOPHUS_CHAT_COUNTRIES } from '../../../constants';
import ServiceHandler from '@/services/service-handler';
interface Props {
    chatVisible: boolean;
    language: string;
    helpRouterContent: HelpRouterFragment;
}

const HelpRouterInnerLinks = (props: Props) => {
    const appConfigurationService =
        ServiceHandler.AppConfigurationService.getAppConfiguration();

    return (
        <>
            <div className={'help-router-sticky-cta-inner'}>
                <div className={'help-router-inner-links-wrapper'}>
                    <a
                        className={'help-router-inner-link'}
                        href={
                            props.helpRouterContent?.mainMenu.menuItem.item1
                                .item1CtaUrlPath
                        }
                        aria-label={
                            props.helpRouterContent?.mainMenu.menuItem.item1
                                .item1AriaLabel
                        }
                    >
                        {props.helpRouterContent?.mainMenu.menuItem.item1
                            .item1IconPath && (
                            <img
                                src={`${process.env.REACT_APP_AEM_BASE_URL}${props.helpRouterContent?.mainMenu.menuItem.item1.item1IconPath}`}
                                alt=""
                            ></img>
                        )}
                        {
                            props.helpRouterContent?.mainMenu.menuItem.item1
                                .item1CtaTitle
                        }
                    </a>
                </div>
                <div className={'help-router-inner-links-wrapper'}>
                    <a
                        className={'help-router-inner-link'}
                        href={
                            props.helpRouterContent?.mainMenu.menuItem.item2
                                .item2CtaUrlPath
                        }
                        aria-label={
                            props.helpRouterContent?.mainMenu.menuItem.item2
                                .item2AriaLabel
                        }
                    >
                        {props.helpRouterContent?.mainMenu.menuItem.item2
                            .item2IconPath && (
                            <img
                                src={`${process.env.REACT_APP_AEM_BASE_URL}${props.helpRouterContent?.mainMenu.menuItem.item2.item2IconPath}`}
                                alt=""
                            ></img>
                        )}
                        {
                            props.helpRouterContent?.mainMenu.menuItem.item2
                                .item2CtaTitle
                        }
                    </a>
                </div>
                <div className={'help-router-inner-links-wrapper'}>
                    <a
                        className={'help-router-inner-link'}
                        href={
                            props.helpRouterContent?.mainMenu.menuItem.item3
                                .item3CtaUrlPath
                        }
                        aria-label={
                            props.helpRouterContent?.mainMenu.menuItem.item1
                                .item1AriaLabel
                        }
                    >
                        {props.helpRouterContent?.mainMenu.menuItem.item3
                            .item3IconPath && (
                            <img
                                src={`${process.env.REACT_APP_AEM_BASE_URL}${props.helpRouterContent?.mainMenu.menuItem.item3.item3IconPath}`}
                                alt=""
                            ></img>
                        )}
                        {
                            props.helpRouterContent?.mainMenu.menuItem.item3
                                .item3CtaTitle
                        }
                    </a>
                </div>
                <div className={'help-router-inner-links-wrapper'}>
                    <a
                        className={'help-router-inner-link'}
                        href={
                            props.helpRouterContent?.mainMenu.menuItem.item4
                                .item4CtaUrlPath
                        }
                        aria-label={
                            props.helpRouterContent?.mainMenu.menuItem.item4
                                .item4AriaLabel
                        }
                    >
                        {props.helpRouterContent?.mainMenu.menuItem.item4
                            .item4IconPath && (
                            <img
                                src={`${process.env.REACT_APP_AEM_BASE_URL}${props.helpRouterContent?.mainMenu.menuItem.item4.item4IconPath}`}
                                alt=""
                            ></img>
                        )}
                        {
                            props.helpRouterContent?.mainMenu.menuItem.item4
                                .item4CtaTitle
                        }
                    </a>
                </div>
                {Object.keys(SOPHUS_CHAT_COUNTRIES).includes(
                    appConfigurationService.countryCode
                ) ? (
                    <div id="S3LY_RE9WTF8yMDIz"></div>
                ) : (
                    <div
                        id={props.helpRouterContent?.divTagID?.divTag}
                        className={`live chat ${
                            props.chatVisible ? 'visually-hidden' : ''
                        }`}
                    />
                )}
            </div>
        </>
    );
};
export default HelpRouterInnerLinks;
